import { graphql } from "../generated";

export const SaveCustomSummaryResult = graphql(
  `
    mutation SaveCustomSummaryResult($input: SaveCustomSummaryResultInput!) {
      saveCustomSummaryResult(input: $input) {
        __typename
        ... on CustomSummaryResult {
          ...CustomSummaryResult
        }
        ... on GenericException {
          ...BaseException
        }
        ... on CustomSummaryException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
        ... on InsufficientLicenseException {
          ...InsufficientLicenseException
        }
      }
    }
  `
);
